export const companiesCompanyIdDevelopersTable = "/companies/:company_id/developers/table";
